import Button from "@atoms/Button/Button"

import { useStepStack } from "@molecules/StepStack/StepStack.context"
import { StepStackNavButtonProps } from "@molecules/StepStack/StepStack.types"

function StepStackNextButton(props: StepStackNavButtonProps) {
    const { children = "Next", variant = "solid", size = "md", noDebounce = true, ...rest } = props
    const { orderedIds, currentItemId, navigateTo } = useStepStack()

    const currentIndex = currentItemId ? orderedIds.indexOf(currentItemId) : -1
    const nextId = currentIndex >= 0 && currentIndex < orderedIds.length - 1 ? orderedIds[currentIndex + 1] : null
    const isDisabled = nextId === null

    return (
        <Button
            {...rest}
            type="button"
            variant={variant}
            size={size}
            onClick={() => (nextId ? navigateTo(nextId) : undefined)}
            noDebounce={noDebounce}
            isDisabled={isDisabled}
        >
            {children}
        </Button>
    )
}

export default StepStackNextButton
